"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RubricRatingService = void 0;
var insync_assess_sdk_1 = require("@greatmindsorg/insync-assess-sdk");
var base_service_1 = require("../base.service");
var api_constants_1 = require("../../constants/api.constants");
var helpers_1 = require("../../helpers");
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var models_1 = require("../../models");
var constants_1 = require("../../constants");
var RubricRatingService = /** @class */ (function (_super) {
    __extends(RubricRatingService, _super);
    function RubricRatingService(options, rubricRatingClient) {
        var _this = _super.call(this, options) || this;
        _this.rubricRatingClient = rubricRatingClient;
        return _this;
    }
    RubricRatingService.newInstance = function (options) {
        var clientOptions = {
            baseURL: api_constants_1.ASSESSMENTS_API_BASE_URL,
        };
        var retryOptions = options.retryOptionsOnNonAuthorized;
        return new RubricRatingService(options, insync_assess_sdk_1.RubricRatingClient.newInstance(clientOptions, retryOptions));
    };
    /**
     * Returns the rubric rating by context and assessment
     * @param classes
     * @param assessmentTemplate
     */
    RubricRatingService.prototype.findByContextAndAssessment = function (classes, assessments) {
        return __awaiter(this, void 0, void 0, function () {
            var contextIds, assessmentIds, rubrics;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        contextIds = classes.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        assessmentIds = assessments.map(function (_a) {
                            var id = _a.id;
                            return id;
                        });
                        return [4 /*yield*/, this.rubricRatingClient.findByContextAndAssessment(contextIds, assessmentIds, this.getDefaultHeaders())];
                    case 1:
                        rubrics = _a.sent();
                        return [2 /*return*/, rubrics.map(function (_a) {
                                var userId = _a.userId, responses = _a.responses, externalItemId = _a.externalItemId;
                                return new models_1.RubricRating({
                                    userId: userId,
                                    responses: responses === null || responses === void 0 ? void 0 : responses.map(function (_a) {
                                        var key = _a.key, value = _a.value;
                                        return new models_1.QuestionRubricResponses({ key: key, value: value });
                                    }),
                                    externalId: externalItemId,
                                });
                            })];
                }
            });
        });
    };
    /**
     * Retrieves assignee rubric rating performances
     * @param users                  - student list
     * @param rubricRatings          - rubric ratings by assessment and class
     */
    RubricRatingService.prototype.getAssigneesRubricRatingsByClassAndAssessment = function (users, criterias, rubricRatings) {
        var _this = this;
        var itemPerformances = criterias.map(function (itemCriteria) {
            return users.map(function (user) {
                var _a;
                var assigneeRubricRating = rubricRatings.filter(function (_a) {
                    var userId = _a.userId;
                    return userId === user.id;
                });
                var itemResponses = (_a = assigneeRubricRating.find(function (rubricRating) { return rubricRating.externalId === itemCriteria.externalId; })) === null || _a === void 0 ? void 0 : _a.responses;
                if (!(0, isEmpty_1.default)(itemResponses)) {
                    var assigneeItemCriteriaPerformances = itemCriteria.criteria.map(function (section, i) {
                        var studentCriteriaRating = itemCriteria.type === constants_1.ScoringType.Rating
                            ? itemResponses[i]
                            : itemResponses.find(function (_a) {
                                var key = _a.key;
                                return key === section;
                            });
                        if (studentCriteriaRating === undefined) {
                            return null;
                        }
                        var rubricCriteriaScore = _this.getScoreFromRubric(studentCriteriaRating, itemCriteria.type);
                        return new models_1.RubricCriteriaPerformance({
                            key: studentCriteriaRating === null || studentCriteriaRating === void 0 ? void 0 : studentCriteriaRating.key,
                            value: studentCriteriaRating === null || studentCriteriaRating === void 0 ? void 0 : studentCriteriaRating.value,
                            score: rubricCriteriaScore,
                            maxScore: 1,
                            percentage: (0, helpers_1.getPercentage)(rubricCriteriaScore, 1),
                        });
                    });
                    var score = _this.calculateScore(assigneeItemCriteriaPerformances.filter(function (performance) { return !!performance; }));
                    return new models_1.AssigneeRubricPerformance({
                        assignee: user,
                        maxScore: itemCriteria.criteria.length,
                        score: score,
                        overallPercentage: (0, helpers_1.getPercentage)(score, itemCriteria.criteria.length),
                        rubricCriteriaPerformances: assigneeItemCriteriaPerformances,
                    });
                }
                return null;
            });
        });
        return itemPerformances.map(function (performance) {
            return performance.filter(function (assigneePerformance) { return !!assigneePerformance; });
        });
    };
    /**
     * Retrieves the overall of assignee rubric performances.
     * @param {number[]}                        criterias              - rubric criteria list
     * @param {AssigneeRubricPerformance[]}     assigneesPerformances  - List of assignees rubric performances
     */
    RubricRatingService.prototype.getItemOverallAssigneeRubricPerformances = function (criterias, assigneesPerformances) {
        var _this = this;
        var overallRubricPerformances = criterias.map(function (criteria) {
            var rubricCriteriaPerformanceData = [];
            assigneesPerformances.forEach(function (assignee) {
                var _a;
                var criteriaPerfomance = (_a = assignee === null || assignee === void 0 ? void 0 : assignee.rubricCriteriaPerformances) === null || _a === void 0 ? void 0 : _a.filter(function (rubricCriteriaPerformance) { return !(0, isEmpty_1.default)(rubricCriteriaPerformance); }).find(function (rubricCriteriaPerformance) { return (rubricCriteriaPerformance === null || rubricCriteriaPerformance === void 0 ? void 0 : rubricCriteriaPerformance.key) === criteria; });
                if (criteriaPerfomance) {
                    rubricCriteriaPerformanceData.push(criteriaPerfomance);
                }
            });
            var averageCriteriaScore = _this.calculateScore(rubricCriteriaPerformanceData);
            return new models_1.RubricCriteriaPerformance({
                key: criteria,
                score: averageCriteriaScore,
                maxScore: rubricCriteriaPerformanceData.length,
                percentage: (0, helpers_1.getPercentage)(averageCriteriaScore, rubricCriteriaPerformanceData.length),
            });
        });
        var overallScore = this.calculateScore(overallRubricPerformances) / assigneesPerformances.length;
        var overallMaxScore = this.calculateMaxScore(overallRubricPerformances) / assigneesPerformances.length;
        return new models_1.AssigneeRubricPerformance({
            score: overallScore,
            maxScore: overallMaxScore,
            overallPercentage: (0, helpers_1.getPercentage)(overallScore, overallMaxScore),
            rubricCriteriaPerformances: overallRubricPerformances,
        });
    };
    /**
     * Returns the list of rubric criterias
     * @param responses     - rubric responses
     */
    RubricRatingService.prototype.getCriterias = function (responses) {
        return responses.map(function (_a) {
            var key = _a.key;
            return key;
        });
    };
    /**
     * Return score from rubric
     * @param response     - rubric responses
     */
    RubricRatingService.prototype.getScoreFromRubric = function (response, type) {
        return type === constants_1.ScoringType.Matrix
            ? this.getScoreFromMatrix(response.value)
            : type === constants_1.ScoringType.Rating
                ? this.getScoreFromRating(response.value)
                : 0;
    };
    /**
     * Return score from rating
     * @param value - string or null
     */
    RubricRatingService.prototype.getScoreFromRating = function (value) {
        return value === '3' || value === '4' ? 1 : 0;
    };
    /**
     * Return score from matrix
     * @param value - number or null
     */
    RubricRatingService.prototype.getScoreFromMatrix = function (value) {
        return value === 0 ? 1 : 0;
    };
    /**
     * Returns average score of  rubric criteria performance list
     * @param rubricCriteriaPerformances     - rubric criteria performances
     */
    RubricRatingService.prototype.calculateScore = function (rubricCriteriaPerformances) {
        return rubricCriteriaPerformances.reduce(function (total, assessment) { return total + assessment.score; }, 0);
    };
    /**
     * Returns average score of  rubric criteria performance list
     * @param rubricCriteriaPerformances     - rubric criteria performances
     */
    RubricRatingService.prototype.calculateMaxScore = function (rubricCriteriaPerformances) {
        return rubricCriteriaPerformances.reduce(function (total, assessment) { return total + assessment.maxScore; }, 0);
    };
    return RubricRatingService;
}(base_service_1.BaseService));
exports.RubricRatingService = RubricRatingService;
